import styles from "./Footer.module.css";

const Footer = () => {
  return (
    <div className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.medicalIconiPhysicalTherapParent}>
          <img
            className={styles.medicalIconiPhysicalTherap}
            alt=""
            src="/medicaliconiphysicaltherapy.svg"
          />
          <div className={styles.logo}>
            <img className={styles.logo1Icon} alt="" src="/logo-1.svg" />
            <b className={styles.personal}>
              <p className={styles.jJPhysical}>{`J &J Physical`}</p>
              <p className={styles.jJPhysical}>Therapy</p>
            </b>
          </div>
        </div>
        <div className={styles.byDavidRoseParent}>
          <div className={styles.byDavidRose}>@2024 By David Rose</div>
          <div className={styles.madeInFigma}>Made In Figma</div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
